










































import { CartScopeEq } from '@/models/cart/group/scope'
import { FkuQuery } from '@/services/api/item/fku/fku-query'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import SlickCarousel from '@/directives/slick-carousel'

import Item from '@/components/molecules/ItemWithLink.vue'
import ItemList from '@/components/organisms/ItemList.vue'
import AppId from '@/util/appid'

import { log } from '@/log'
import { ApiProduct } from '@/models/api/product'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { ItemKind } from '@/models/item/kind'
import ItemService from '@/services/api/productclass'

@Component({
  directives: {
    SlickCarousel,
  },
  components: {
    Item,
    ItemList,
  },
})
export default class RecommendItems extends Vue {
  @Prop({ required: true })
  scope: CartScopeEq

  @Prop({ required: true })
  query: object

  @Prop({ default: null })
  brand: string | null

  @Prop({ required: true })
  itemListUrl: string

  itemlist: any[] = []

  errorMessage: string = ''

  slickOptions = {
    rows: 0, // see https://github.com/kenwheeler/slick/issues/3149
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: `<div
      class="p-cart-recommend-carousel__arrow p-cart-recommend-carousel__arrow--prev"
    />`,
    nextArrow: `<div
      class="p-cart-recommend-carousel__arrow p-cart-recommend-carousel__arrow--next"
    />
    `,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
        },
      },
    ],
  }

  isLoading: boolean = true

  showMoreLink: boolean = false

  readonly DISPLAY_COUNT = 10

  get hasError(): boolean {
    return this.errorMessage.length > 0
  }

  get hasItem(): boolean {
    return this.itemlist.length > 0
  }

  get baseQuery(): FkuQuery {
    return FkuQuery.initializeForListView({
      limit: this.DISPLAY_COUNT + 1, // increment for showMoreLink
      'part.stock_quantity': '1~',
    }).withoutByTag([
      ApiProduct.TAG_PATHNAME_RESTOCK,
      ApiProduct.TAG_PATHNAME_NEWITEM,
    ])
  }

  get itemKind(): ItemKind {
    const behavior = BehaviorConfig.createFromBrand(this.brand)

    return behavior.itemList.layout as ItemKind
  }

  created() {
    this.getItemList()
  }

  async getItemList() {
    try {
      /*
       * ↓から with=like 付きのクエリで呼び出されているので、user依存として取得する必要がある
       * client/spa/src/components/organisms/cart/recommend/PopularItems.vue
       * client/spa/src/components/organisms/cart/recommend/PriceRangeItems.vue
       *
       * @see https://www.chatwork.com/#!rid87550748-1485380185053200384
       */
      const result =  await this.itemService.listFku(
        this.baseQuery.addQuery(this.query).toObject()
      )
      if (result.isLeft()) {
        this.errorMessage = 'データを取得できませんでした'

        return
      }

      const items = this.itemlist.concat(result.value)
      if (items.length === 0) {
        this.errorMessage = 'おすすめ商品が見つかりませんでした'

        return
      }

      this.showMoreLink = items.length > this.DISPLAY_COUNT
      this.itemlist = items.slice(0, this.DISPLAY_COUNT)
    } catch (err) {
      log.error(err)
      this.errorMessage = 'データを取得できませんでした'
    } finally {
      this.isLoading = false
    }
  }

  private get itemService(): ItemService {
    switch (this.scope.kind.toString()) {
      case 'brand':
        const appId = AppId.getByBrandName(this.scope.value.toString())

        return new ItemService(appId)
      default:
        return new ItemService()
    }
  }
}
